import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col, Row} from "react-bootstrap";
import {resetEntity, showMessage} from '../actions';
import {loadGeneralEnum} from "../actions/enums";
import {findParties, loadPartyInfo} from "../actions/parties";
import {loadDogInfo} from "../actions/dogs";
import {loadWalk, saveWalk} from '../actions/walks';
import {defaultState} from '../reducers/entity';
import WalkForm from '../components/walk/WalkForm';
import {breadcrumbs, createPartyOption, Date, Grid} from "./../utils";
import {handleTypeheadSearch} from "../components/form/form";
import {PartyRole} from "../utils/enums";

class WalkEditPage extends Component {

	findPartiesTimeout: null;

	constructor(props) {
		super(props);

		this.handleFetchEnums = this.handleFetchEnums.bind(this);
		this.handleSaveWalk = this.handleSaveWalk.bind(this);
		this.handleFindParties = this.handleFindParties.bind(this);

		this.state = {
			party: null,
			dog: null
		};
	}

	componentWillMount() {
		const {walkId, partyId} = this.props.match.params;
		if (walkId) {
			this.loadWalk(walkId);
		} else if (partyId) {
			this.setState({party: false});
			this.props.loadPartyInfo(partyId).then((json) => {
				if (json && json.response && json.response.result === 'OK') {
					this.setState({party: json.response.data});
				}
			});
		}
	}

	componentWillReceiveProps(nextProps) {
		const nextWalkId = nextProps.match.params.walkId;
		if ((nextWalkId || 'new') !== (this.props.match.params.walkId || 'new')) {
			if (nextWalkId) {
				this.loadWalk(nextWalkId);
			} else if (nextProps.match.params.partyId) {
				this.setState({party: false});
				this.props.loadPartyInfo(nextProps.match.params.partyId).then((json) => {
					if (json && json.response && json.response.result === 'OK') {
						this.setState({party: json.response.data});
					}
				});
			}
		} else {
			this.props.resetEntity("walk");
		}
	}

	loadWalk(walkId) {
		this.setState({party: false, dog: false});
		this.props.loadWalk(walkId).then((json) => {
			if (json && json.response && json.response.result === 'OK') {
				const w = json.response.data;
				this.props.loadPartyInfo(w.partyId).then((json) => {
					if (json && json.response && json.response.result === 'OK') {
						this.setState({party: json.response.data});
					}
				});
				this.props.loadDogInfo(w.dogId).then((json) => {
					if (json && json.response && json.response.result === 'OK') {
						this.setState({dog: json.response.data});
					}
				});
			}
		})
	}

	componentWillUnmount() {
		if (this.findPartiesTimeout) {
			clearTimeout(this.findPartiesTimeout);
		}
		this.props.resetEntity("walk");
	}

	handleFetchEnums(enums) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], {})
			}
		}
	}

	handleFindParties(search, callback, currentParty = null) {
		if (this.findPartiesTimeout) {
			clearTimeout(this.findPartiesTimeout);
		}
		this.findPartiesTimeout = setTimeout(() => {
			handleTypeheadSearch({search, roles: [PartyRole.WALKER]}, createPartyOption, this.props.findParties, callback, currentParty);
		}, search ? 500 : 0);
	}

	handleSaveWalk(walk) {
		return this.props.saveWalk(walk).then((json) => {
			if (json && json.response && json.response.result === 'OK') {
				const walkId = json.response.data.walkId;
				let m = json.response.message;
				const d = json.response.data;
				const t = d.walkDate + ' (ID ' + walkId + ')'
				if (m === 'NO_CHANGE') {
					m = 'Vycházka uložena beze změn: ' + t;
				} else if (m === 'UPDATED') {
					m = 'Vycházka úspěšně upravena: ' + t;
				} else if (m === 'CREATED') {
					m = 'Vycházka úspěšně vytvořena: ' + t;
				}
				this.props.showMessage(m);
				return new Promise((resolve, reject) => resolve(this.props.history.push('/vychazky/' + walkId)))
			} else {
				this.props.showMessage("Uložení selhalo: " + (json.error || JSON.stringify(json)), 'error');

				return new Promise((resolve, reject) => resolve())
			}
		})
	}

	render() {
		const {match: {params}, entity, session, enums} = this.props;
		const {party, dog} = this.state;

		if (entity.isFetchingItem || entity.item === null || party === false || dog === false) {
			return Grid.renderIsFetchingData()
		}

		const initialValues = entity.item;
		if (!initialValues.walkId) {
			initialValues.walkDate = Date.today();
			if (party) {
				initialValues.partyId = party.partyId;
			}
		}
		const bc = [
			{url: '/vychazky', title: 'Vycházky'}
		];
		if (params.walkId) {
			bc.push({
				url: '/vychazky/' + params.walkId, title: entity && entity.item && entity.item.walkId
					? (
						(party ? party.lastName + ' ' + party.firstName : "?")
						+ " a " +
						(dog ? dog.name : "?")
						+ " " + Date.formatDate(entity.item.walkDate)
						+ " " + Date.formatDate(entity.item.walkDate)
					)
					: '...', literal: true
			});
			bc.push({url: '/vychazky/' + params.walkId + '/uprava', title: 'Úprava'});
		} else {
			bc.push({url: '/vychazky/nova', title: 'Nová'});
		}

		return (
			<div>
				<Row>
					<Col xs={12}>
						{breadcrumbs(bc)}
					</Col>
				</Row>
				<WalkForm {...entity} initialValues={initialValues} party={this.state.party} dog={this.state.dog}
					onSaveWalk={this.handleSaveWalk}
					onDeleteWalk={this.handleOpenDeleteClick}
					onFindParties={this.handleFindParties}
					onFetchEnums={this.handleFetchEnums} enums={enums} session={session}/>
			</div>
		)
	}
}

WalkEditPage.propTypes = {
	entity: PropTypes.object.isRequired,
	loadWalk: PropTypes.func.isRequired,
	saveWalk: PropTypes.func.isRequired,
	findParties: PropTypes.func.isRequired,
	loadPartyInfo: PropTypes.func.isRequired,
	loadDogInfo: PropTypes.func.isRequired,
	loadGeneralEnum: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	enums: PropTypes.object,
	session: PropTypes.object.isRequired,
};


const mapStateToProps = (state, ownProps) => {
	const {
		entities: {walks},
		enums,
		session
	} = state;

	const entity = ownProps.match.params.walkId
		? (walks[ownProps.match.params.walkId] || defaultState)
		: (walks['new'] || Object.assign(defaultState, {item: {}}));

	return {
		entity,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadWalk,
	saveWalk,
	findParties,
	loadPartyInfo,
	loadDogInfo,
	loadGeneralEnum,
	showMessage,
	resetEntity
})(WalkEditPage)



// WEBPACK FOOTER //
// ./src/containers/WalkEditPage.js